<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div  class="margin-left-l font-s">选择</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <vue-custom-scrollbar class="flex flex-col body padding-top-l border-box  " style="height: calc(100% - 100px)" >
                <div class="flex margin-left-l flex-space-between border-box">
                    <div class="flex flex-center-cz">
                        <span>选择文档：</span>
                        <MySelect :data="docData"   @change="selectChange" style="width: 400px;"></MySelect>
                    </div>
                    <div class="margin-right-l">
                        已选中：<span class="color-blue">{{selectData.length}}</span>项
                    </div>

                </div>

                <my-table @checkboxChange="checkChange"  :showCheck="true" class=" margin-m" :fields="fields" :data="tableData" :opFields="[]">  
                </my-table>
            </vue-custom-scrollbar>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box"> 
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>         
            </div>
        </div>
    </div>
</template>

<script>
    import MySelect from '@/components/select/Select' 
    import MyTable from '@/components/table/Table' //引入我们写好的递归组件
    import {getMyQuestionDocs,getQuestionTitles} from '@/api/api.js';   
    import { objToStr } from '../../utils/sysUtils';
    import XSelect from '@/components/xSelect/XSelect.vue';
 
   

    export default {
        name:'SelectQuestionModal',
        created() {
        },
        components:{MySelect,XSelect,MyTable},
        data() {
            return {
                show: null,     
                docData:[],         
                tableData:[],
                selectData:[],
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),
                fields: [
                    {title:'试题',fieldName:'value',width:'',type:'text', align:'left'},
                ],

            }
        },
        methods:{
            showForm() {
                this.docData = [];
                this.tableData = [];
                this.selectData = [];
                getMyQuestionDocs().then((res) => {
                    let data = [];
                    res.data.result.forEach(item => {
                        data.push({value: item.fileId, text: item.name})                       
                    });
                    this.docData = data;
                    console.log("res====", res);
 
                })
                this.show = true;
        
            },
            selectChange(data) {
                getQuestionTitles(data).then((res) => {
                    this.tableData = res.data.result;
                    console.log("res====", res);
 
                })
            },
            confirm() {
                let data = [];
                this.selectData.forEach(item => {
                    let find = this.tableData.filter(d=>d.id == item);
                    data.push(find[0].dataId);                    
                });
                console.log(data)
                this.$emit("add", data.join(","))                
            },
            close() {
                this.show = false;
            },
            checkChange(data) {
                this.selectData = data

            }
        }
   }
</script>

<style scoped>

    .form-modal {
        top: 100px;
    }
    .doc-edit-modal {
        width: 950px;
        height: 650px;
    }
    .edit-area {
       width: 600px;
    }
 

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/plugs/SelectQuestionModal.vue